<template>

	<div class="board_list">

		<ul class="gallery_list">

			<li :id="'item-' + item.emIdx" v-for="(item, index) in eduList">
				<a href="javascript:;" @click="goLearn(item)">
					<figure class="list_thumb">
						<img v-if="item.thumbnail != null && item.thumbnail !== ''" :src="item.thumbnail" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
						<img v-else src="/ssflex/assets/img/common/img_thumb.svg">
					</figure>
					<div class="list_text">
						<em class="cate">
							<span class="notice_cate m-r-5" v-if="item.isMajor">주요</span>
							<span v-if="item.cateCode != null">{{ item.cateCodeVO.codeName }}</span>
						</em>
						<strong class="tit">
							{{ item.shortTitle }} {{ item.eduTitle }}</strong>
						<div class="desc">{{ item.introduce }}</div>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "eduList",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		eduList: Array,
	},
	data() {



		return {
			//eduList: [],
			eduCount: 0,
		}
	},
	created() {

	},
	mounted() {
	},
	methods: {


		goLearn( _item ) {
			if ( this.forApp ) {
				this.goAppEducation(_item.cateCode, _item.emIdx)
			}
			this.$eventBus.$emit("goLearning", _item.emIdx)
		},

	},
}
</script>

<style scoped>

</style>